export default __webpack_public_path__ + "static/media/AVT.273f3cf3.png";